// removed by extract-text-webpack-plugin
module.exports = {"scrollWindowButton":"styles__scrollWindowButton__3h3FP","scrollWindowButtonVisible":"styles__scrollWindowButtonVisible__34FK0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollWindow/styles.scss
// module id = 845
// module chunks = 0